// extracted by mini-css-extract-plugin
module.exports = {"viewer":"Viewer_viewer__3Mmqk","arButton":"Viewer_arButton__3ZZBj","qrCode":"Viewer_qrCode__18a4b"};